// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"QuickAnswers_wrapper__3IUu-"};